import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { sortBy, orderBy } from 'lodash-es';
import GridItem from './GridItem';
import DataContext from '../DataContext/DataContext';
import MenuCategoryList from '../MenuCategory/MenuCategoryList';
import useQueryParams from '../util/useQueryParams';
import useRoutes from '../../routes/useRoutes';
import TextTranslatable from '../Internationalization/TextTranslatable';
import { getCoworkerCategory } from '../../features/config/select';

const ContainerStyle = styled.div`
  margin: 0 auto;
  max-width: 1000px;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  padding: 16px;
  color: rgba(0, 0, 0, 0.87);
`;
const tween = {
  type: 'tween',
  duration: 0.2,
  ease: 'easeInOut'
};
const StyledSpan = styled.span`
  background-color: #FFDB00;
  padding: 5px 10px;
  position: fixed;
  bottom: 15px;
  max-width: 250px;
  // bottom: 300px;
  right: 30px;
  // transform: translateY(-50%) rotate(-90deg);
  // transform-origin: right center;
`;



const GridItemFramer = motion(GridItem);


const DishGrid = () => {
  const [categoryParam] = useQueryParams('category');
  const [selectedCategory, setSelectedCategory] = useState(categoryParam);
  const { ppsis, config, language, allStores ,} = useContext(DataContext);
  const selectedStore = JSON.parse(localStorage.getItem('store'));

  let storeName = <TextTranslatable textId="no_store_selected" />
  if(selectedStore && selectedStore.length === 1){
    storeName =  config.storeCode.filter(a=>selectedStore.includes(a.code))[0].info[language].name
  }

  const history = useHistory();
  const location = useLocation();
  const routes = useRoutes();
  
  let codes = [];
  if (selectedCategory) {
    const category = getCoworkerCategory(config, selectedCategory);
    if (category) {
      codes = category.codeList;
    }
  }

  let aplhaSortedPpsis = sortBy(ppsis, `info.${language}.presentationName`);

  let isUpdatedDish = [];
  let isNewDish = [];
  let alphabeticalSorted = [];

  // check for updated/new ppsis
  aplhaSortedPpsis && aplhaSortedPpsis.filter(item =>{
    if (item.ppsiTag === 'updated') {
      isUpdatedDish.push(item);
    } else if (item.ppsiTag === 'new') {
      isNewDish.push(item);
    }else{
      alphabeticalSorted.push(item)
    }
});

let updatedSorted = isUpdatedDish && orderBy(
  isUpdatedDish,
  ppsis => ppsis.modifyDate,
  'desc'
);

let newSorted =  isNewDish && orderBy(
  isNewDish,
  ppsis => ppsis.actualPublishDate,
  'desc'
);

function sortDishbyDate(data){
  let result = orderBy(
    data,
    ppsis => ppsis.modifyDate,
    'desc'
  );
  return result;
}
let newUpArray = [...newSorted, ...updatedSorted]
let finArray = orderBy(
  newUpArray,
  ppsis => ppsis.latestKCUpdate,
  'desc'
)

//  let sortedPpsis = [ ...finArray, ...alphabeticalSorted]
 let sortedPpsis = [ ...newUpArray, ...alphabeticalSorted]
 

  if (location.data && location.data['menuSelected']) {
    // var showAsTill = 300;
    let dateBasedArray = [];
    var newTagArray = [];
    var updatedTagArray = [];
    var alphabeticalBasedArray = [];
    if (
      location.data['menuSelected'].key === 'new' ||
      location.data['menuSelected'].key === 'updated' ||
      location.data['menuSelected'].key === 'alphabetic'
    ) {
      sortedPpsis.map(item => {
        // if (
        //   (new Date().getTime() - new Date(item.actualPublishDate).getTime()) /
        //     (1000 * 3600 * 24) <
        //   showAsTill
        // ) {
        //   item.newPpsi = true;
        //   dateBasedArray.push(item);
        // } else {
        //   item.newPpsi = false;
        //   alphabeticalBasedArray.push(item);
        // }
        if (location.data['menuSelected'].key === 'new') {
          if (item.ppsiTag === 'new') {
            newTagArray.push(item);
          } else if (item.ppsiTag === 'updated') {
            updatedTagArray.push(item);
          } else {
            alphabeticalBasedArray.push(item);
          }
          let res1 = sortDishbyDate(newTagArray)
          let res2 = sortDishbyDate(updatedTagArray)
          dateBasedArray = [...res1, ...res2]
        } else if (location.data['menuSelected'].key === 'updated') {
          if (item.ppsiTag === 'updated') {
            updatedTagArray.push(item);
          } else if (item.ppsiTag === 'new') {
            newTagArray.push(item);
          } else {
            alphabeticalBasedArray.push(item);
          }
          let res1 = sortDishbyDate(updatedTagArray)
          let res2 = sortDishbyDate(newTagArray)
          dateBasedArray = [...res1, ...res2]
        } else if (location.data['menuSelected'].key === 'alphabetic') {
            alphabeticalBasedArray.push(item);
        }
      });


      // let result1 = orderBy(
      //   dateBasedArray,
      //   ppsis => ppsis.actualPublishDate,
      //   'desc'
      // );
      let result2 = sortBy(
        alphabeticalBasedArray,
        ppsis => ppsis.info[language] && ppsis.info[language].presentationName
      );

      sortedPpsis = [...dateBasedArray, ...result2];
    }
  }
  // console.log(sortedPpsis);
  const ppsisMatchingCategory = sortedPpsis.filter(
    ppsi => codes.length === 0 || codes.includes(ppsi.piaProductArea)
  );


  const setCategoryCodes = categoryName => {
    history.replace({
      pathname: routes.menuRoute(),
      search: categoryName ? `?category=${categoryName}` : ''
    });
    setSelectedCategory(categoryName);
  };

  const noItemsFound = <p style={{color: 'red', textAlign: 'center'}}>
                          {/* No product found! */}
                          <TextTranslatable textId="no_product_found" />
                          {/* <TextTranslatable textId="unsupported_browser_message" /> */}
                       </p>

  return (
    <ContainerStyle>
      <MenuCategoryList
        selectedCategoryName={selectedCategory}
        onChange={setCategoryCodes}
      />
    {ppsisMatchingCategory.length === 0? noItemsFound :
      <CardsContainer>
         
         {ppsisMatchingCategory.map(ppsi => (
          <GridItemFramer
            positionTransition={tween}
            ppsi={ppsi}
            key={ppsi.id}
          />
        ))}
      </CardsContainer>}
      <span className='rtlSpan'>{storeName}</span>
    </ContainerStyle>
  );
};

export default DishGrid;
